/* eslint-disable camelcase */
import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { createUseStyles } from "react-jss";
import axios from "axios";
import { setCurrentStop, StopState, setStopState } from "Containers/Stops";
import {
  setShowMediaViewer,
  setMediaParam,
  setDisplay,
  setShowMediaObj,
  setShowSmallViewPort,
} from "Containers/MediaViewer";
import {
  setDestinationsView,
  setSelectedDestinations,
} from "Containers/Destinations";
import { ResultCell } from "Components/SearchAI";
import PageLoader from "Components/loader/pageLoader";
import { setHideSearchAIPrompt, setSearchInputValue } from "./actions";
import { MEDIA_TYPES } from "../../constants";
import styles from "./styles";

interface ResultsProps {
  mapObj: any;
}

const SearchResults = ({ mapObj }: ResultsProps) => {
  const dispatch = useDispatch();
  const { searchLoading, searchAIStops } = useSelector(
    (state: any) => state.searchAI
  );
  const {
    analytics: { userkey, sessionId },
  } = useSelector((state: any) => state.analytics);

  const useStyles = createUseStyles(styles);
  const classes = useStyles();

  const handleResultClick = (e, result) => {
    e.stopPropagation();

    const url = new URL(window.location.href);
    const params = new URLSearchParams(url.search);
    let mediaType = result.media_type;

    params.delete("loc");
    params.delete("media");

    let mediaParams = "";
    if (mediaType !== MEDIA_TYPES.STOP_DESCRIPTION) {
      mediaParams = `${mediaType}:${result.media_id}`;
    }

    const locParams = result.stop_id;
    let newUrl = `${url.pathname}`;
    if (url.search.length > 0) {
      newUrl += `?${params.toString()}`;
      params.set("loc", locParams);
      newUrl += `&loc=${params.get("loc")}`;
    } else {
      params.set("loc", locParams);
      newUrl += `?loc=${params.get("loc")}`;
    }
    if (mediaParams) {
      params.set("media", mediaParams);
      newUrl += `&media=${params.get("media")}`;
    }
    window.history.pushState(null, null, newUrl);

    dispatch(setStopState([result.stop_id], StopState.Selected));
    dispatch(setCurrentStop(result.stop_id));
    dispatch(setDestinationsView(false));
    dispatch(setSelectedDestinations(result.destination?.panoThumb));

    const latLng = mapObj.isCustomTiledMap
      ? new window.google.maps.LatLng(
          result?.destination?.customLat,
          result?.destination?.customLng
        )
      : new window.google.maps.LatLng(
          result?.destination?.realLat,
          result?.destination?.realLng
        );
    mapObj.panTo(latLng);

    if (mediaParams) {
      if (mediaType === "pano") mediaType = "panorama";
      dispatch(setShowMediaViewer(mediaType));
      dispatch(setShowSmallViewPort(true));
      dispatch(setMediaParam(result.media_id));
      dispatch(setDisplay(true));
      dispatch(setShowMediaObj(true));
    } else {
      dispatch(setShowMediaViewer(false));
    }

    dispatch(setHideSearchAIPrompt());
    dispatch(setSearchInputValue(""));

    axios.post(
      `${process.env.REACT_APP_API_BASE_URL}api/v2/analytics/${userkey}/${sessionId}/stops_search_personalization`,
      {
        loc_id: result?.location_id,
        search_request_id: result?.requestId,
        media_type: result?.media_type,
        media_id: result?.media_id || result?.media.id,
        tour_id: result?.tour_id,
        stop_id: result?.stop_id,
      }
    );
  };

  return (
    <div
      role="presentation"
      className={classes.resultsContainer}
      onClick={(e) => e.stopPropagation()}
      onKeyDown={(e) => {
        if (e.key === "Enter" || e.key === " ") {
          e.stopPropagation();
        }
      }}
    >
      {searchLoading ? (
        <PageLoader />
      ) : (
        <>
          <span tabIndex={0} className={classes.resultCount}>
            {`${
              searchAIStops?.filter((result) => result.media)?.length
            } Results`}
          </span>
          <div className={classes.results}>
            {searchAIStops?.map((result: any) => (
              <ResultCell
                result={result}
                key={result.id}
                onClick={handleResultClick}
              />
            ))}

            {searchAIStops?.length > 0 && (
              <span
                tabIndex={0}
                style={{ outline: "none" }}
                onFocus={() => {
                  const el = document.getElementById("close-search-results");
                  el?.focus();
                }}
              />
            )}
          </div>
        </>
      )}
    </div>
  );
};

export default SearchResults;
try {
    // @ts-ignore
    SearchResults.displayName = "SearchResults";
    // @ts-ignore
    SearchResults.__docgenInfo = { "description": "", "displayName": "SearchResults", "props": { "mapObj": { "defaultValue": null, "description": "", "name": "mapObj", "required": true, "type": { "name": "any" } } } };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined")
        // @ts-ignore
        STORYBOOK_REACT_CLASSES["src/shared/containers/SearchAI/SearchResults.tsx#SearchResults"] = { docgenInfo: SearchResults.__docgenInfo, name: "SearchResults", path: "src/shared/containers/SearchAI/SearchResults.tsx#SearchResults" };
}
catch (__react_docgen_typescript_loader_error) { }